import { useEffect, useState } from "react";
import { getCurrentUser, signInWithRedirect } from "aws-amplify/auth";
import "./App.css";

const starterModules = [
  "CDK package wired into the pipeline",
  "Lambda package scaffolded for service entrypoints",
  "Galaxy DAG package scaffolded for orchestration",
  "React package scaffolded for the UI shell",
];

function App() {
  const [alias, setAlias] = useState<string | null>(null);

  useEffect(() => {
    getCurrentUser()
      .then((user) => setAlias(user.username.split("_")[1] ?? user.username))
      .catch(() =>
        signInWithRedirect({ provider: { custom: "AmazonFederate" } }).catch(console.error),
      );
  }, []);

  if (!alias) {
    return null;
  }

  return (
    <main className="app-shell">
      <section className="hero">
        <p className="eyebrow">Sponsored Products</p>
        <h1>SPB Weblab Insight Tool</h1>
        <p className="summary">
          This starter UI mirrors the basic FINN package structure so we can plug in
          auth, data fetching, and AppSync-backed screens incrementally.
        </p>
        <p className="summary">Signed in as {alias}</p>
      </section>

      <section className="status-card">
        <h2>Starter Setup</h2>
        <ul>
          {starterModules.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </main>
  );
}

export default App;
